// swatch-card-label.js
(() => {
  const WRAP_SELECTOR = ".x-swatch-wrap";
  const INIT_ATTR = "data-swatch-init";

  function initWrap(wrap) {
    if (!wrap || wrap.hasAttribute(INIT_ATTR)) return;

    const group = wrap.querySelector("[data-swatch-group]");
    const label = wrap.querySelector("[data-swatch-label]");
    if (!group || !label) return;

    wrap.setAttribute(INIT_ATTR, "1");

    const defaultName = group.getAttribute("data-default-name") || "";
    const setLabel = (name) => (label.textContent = name || defaultName);

    // initial text
    setLabel(defaultName);

    const swatches = group.querySelectorAll(".x-swatch[data-swatch-name]");
    swatches.forEach((a) => {
      const name = a.getAttribute("data-swatch-name") || "";

      a.addEventListener("mouseenter", () => setLabel(name));
      a.addEventListener("focus", () => setLabel(name));

      a.addEventListener("mouseleave", () => setLabel(defaultName));
      a.addEventListener("blur", () => setLabel(defaultName));
    });
  }

  function initAll(root = document) {
    root.querySelectorAll(WRAP_SELECTOR).forEach(initWrap);
  }

  function boot() {
    initAll();

    // Watch for product cards being injected (load more, filters, quick view, etc.)
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.matches?.(WRAP_SELECTOR)) initWrap(node);
          node.querySelectorAll?.(WRAP_SELECTOR).forEach(initWrap);
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Also catch Shopify section reloads
    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
